import React, {FC, useEffect} from 'react';
import './App.scss';
import {connect} from 'react-redux';
import {Switch, Route, useLocation, useHistory} from "react-router-dom";
import {initApp} from "./modules/System";
import {routesArray} from "./routes";
import {cleanSelectedTastes} from "./modules/TastesBrand";
import {setCurrentCompilations} from "./modules/Main";
import WrapperPreloader from "./components/WrapperPreloader";
import {regExGroupCard} from "./constants";
import WrapperAnimation from "./components/WrapperAnimation";

interface IAppProps {
    initApp: any,
    cleanSelectedTastes: any,
    tastes: Array<object>,
    setCurrentCompilations: any,
    isLoading: boolean
}

const App: FC<IAppProps> = ({
                                initApp,
                                cleanSelectedTastes,
                                tastes,
                                setCurrentCompilations,
                                isLoading
                            }) => {

    const history = useHistory();

    useEffect(() => {
        initApp(history);
        // eslint-disable-next-line
    }, []);


    const {pathname} = useLocation();
    useEffect(() => {
        if (pathname === "/mixer" && tastes.length > 0) {
            cleanSelectedTastes();
        }
        if (regExGroupCard.test(pathname)) {
            setCurrentCompilations(null, +pathname.charAt(23));
        }
        // eslint-disable-next-line
    }, [pathname]);

    return (
        <div className="app">
            <WrapperPreloader isLoading={isLoading}>
                <Switch>
                    {
                        routesArray.map((item: any, index: number) => (
                            <Route
                                exact={item.exact}
                                path={item.path}
                                key={index}
                            >
                                <WrapperAnimation>
                                    <item.component/>
                                </WrapperAnimation>
                            </Route>
                        ))
                    }
                </Switch>
            </WrapperPreloader>
        </div>
    );
};

const mapStateToProps = (state: any) => ({
    tastes: state.tastesBrand.tastes,
    isLoading: state.system.isLoading,
});

const mapDispatchToProps = (dispatch: any) => ({
    initApp: (history: History) => dispatch(initApp(history)),
    cleanSelectedTastes: () => dispatch(cleanSelectedTastes()),
    setCurrentCompilations: (id?: number, isGroupCard?: number) => dispatch(setCurrentCompilations(id, isGroupCard)),
});

export default connect(mapStateToProps,
    mapDispatchToProps,
)(App)

